import {
  UserApi, CatalogApi, ClientsApi, Configuration, ShoppingApi,
  LookApi, CommonApi, ProductsApi, CommentsApi, ServiceApi, SupplierApi,
  AiApi, PromoCardApi, StoriesApi, SandboxApi, FilesApi, CompilationsApi,
} from '@/api';
import { getAuthToken } from '@/utils';

function getApiKey(): string | undefined {
  const token = getAuthToken();
  return token ? `Bearer ${token}` : undefined;
}

export default {
  userService: () => new UserApi(new Configuration({ apiKey: getApiKey() })),
  catalogService: () => new CatalogApi(new Configuration({ apiKey: getApiKey() })),
  clientsService: () => new ClientsApi(new Configuration({ apiKey: getApiKey() })),
  shoppingApi: () => new ShoppingApi(new Configuration({ apiKey: getApiKey() })),
  looksApi: () => new LookApi(new Configuration({ apiKey: getApiKey() })),
  commonApi: () => new CommonApi(new Configuration({ apiKey: getApiKey() })),
  productsApi: () => new ProductsApi(new Configuration({ apiKey: getApiKey() })),
  commentsApi: () => new CommentsApi(new Configuration({ apiKey: getApiKey() })),
  serviceApi: () => new ServiceApi(new Configuration({ apiKey: getApiKey() })),
  supplierApi: () => new SupplierApi(new Configuration({ apiKey: getApiKey() })),
  aiApi: () => new AiApi(new Configuration({ apiKey: getApiKey() })),
  promoCardApi: () => new PromoCardApi(new Configuration({ apiKey: getApiKey() })),
  storiesApi: () => new StoriesApi(new Configuration({ apiKey: getApiKey() })),
  sandboxApi: () => new SandboxApi(new Configuration({ apiKey: getApiKey() })),
  filesApi: () => new FilesApi(new Configuration({ apiKey: getApiKey() })),
  compilationsApi: () => new CompilationsApi({ apiKey: getApiKey() }),
};
